<template>
	<input
		v-model="model"
		type="text"
		class="rounded-md px-3 py-3 focus:outline-none"
	/>
</template>

<script>
export default {
	props: {
		value: {
			type: String,
			default: '',
		},
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
};
</script>

<style lang="scss" scoped>
</style>